<template>
    <el-dialog :title="title" :visible.sync="visible" width="500px" :close-on-click-modal="false">
        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
            <el-form-item label="热搜词" prop="name">
                <el-input maxlength="10" v-model="form.name" placeholder="请输入热搜词（十个字以内）"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button @click="visible = false">取消</el-button>
            <el-button type="primary" @click="handleConfirm">确认</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { add, edit } from "@/api/content/hot";
export default {
    data() {
        return {
            title: "添加热搜词",
            visible: false,
            form: {
                name: "",
            },
            rules: {
                name: [{ required: true, message: "请输入热搜词" }],
            },
        };
    },
    methods: {
        open(row) {
            this.visible = true;
            if (row) {
                this.title = "编辑热搜词";
                this.form = { ...row, name: row.name };
            } else {
                this.title = "添加热搜词";
                this.form = { name: "", status: "1" };
                this.$nextTick(() => {
                    this.$refs.form.clearValidate();
                });
            }
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                if (this.form.uuid) {
                    edit(this.form).then(({ code, error }) => {
                        if (code == 200) {
                            this.$message.success("编辑成功");
                            this.visible = false;
                            this.$emit("update");
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                } else {
                    add(this.form).then(({ code, error }) => {
                        if (code == 200) {
                            this.$message.success("添加成功");
                            this.visible = false;
                            this.$emit("update");
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                }
            });
        },
    },
};
</script>

<style></style>
